/**
 * @page security store
 * @author
 * @Date 2018/7/2
 */

import { action, configure, makeAutoObservable } from 'mobx';

import securityService from '../service/securityService';

configure({
  enforceActions: 'always',
});

export default class securityStore {
  constructor(rootStore) {
    makeAutoObservable(this, {
      getSecurityInfo: action,
    });

    this.rootStore = rootStore;
  }

  // 安全中心 信息
  securityInfo = {
    lastLoginIp: '', // ip
    loginPwdLevel: 0, // 密码等级
    loginGoogleSwitch: false, // 登录谷歌是否开启

    phone: '',
    phoneExist: false, // 手机是否存在  该字段为前端根据phone判断
    tradeSmsSwitch: false, // 手机开启

    googleExist: false, // 谷歌是否存在
    tradeGoogleSwitch: false, // 交易是否需要谷歌验证

    tradePwdExist: false, // 资金密码 是否存在

    passkeyExist: false, // 通行密钥 是否存在

    email: '',
    emailExist: false, // 邮箱手否存在  该字段为前端根据email判断
    emailValidateFlag: 0, // 邮箱激活标志
    subEmailModifyFlag: '',

    tradeFrequency: 0, // 交易密码输入频率

    emailVerify: '', // 防钓鱼码

    withdrawLimit: '',
    withdrawLimitJpy: 0,
    withdrawLimitCoin: 0,
    withdrawLimitExist: false, // 最大提现额度是否设置
    restrictPrompt: '',
    restricted: 0, // 是否限制用户修改提币额，0:无限制 1:限制
  };

  // 是否已经获取到安全中心信息
  got = false;

  // 正在请求
  fetching = false;

  // 获取信息
  /**
   * 获取信息
   * @param showGuide 展示引导
   */
  getSecurityInfo(showGuide) {
    // 正在请求
    this.fetching = true;
    // 展示loading
    this.rootStore.loadingStore.showLoading();
    securityService
      .getInfo()
      .then(
        action((data) => {
          this.rootStore.loadingStore.hideLoading();
          // 已经获取到数据
          this.got = true;
          // 请求完成
          this.fetching = false;
          const { info, withdrawInfo } = data;
          this.securityInfo = info;
          const phoneExist = info.phone && info.phone.length !== 0;
          const emailExist = info.email && info.email.length !== 0;
          const passkeyExist = info.passkeyExist || false;
          const withdrawLimitExist =
            withdrawInfo &&
            (withdrawInfo.withdrawLimitCoin !== undefined ||
              withdrawInfo.withdrawLimitJpy !== undefined) &&
            (Number(withdrawInfo.withdrawLimitCoin) >= 0 ||
              Number(withdrawInfo.withdrawLimitJpy) >= 0);
          this.securityInfo.withdrawLimitExist = withdrawLimitExist;
          this.securityInfo.withdrawLimitJpy = withdrawLimitExist
            ? withdrawInfo.withdrawLimitJpy
            : 0;
          this.securityInfo.withdrawLimitCoin = withdrawLimitExist
            ? withdrawInfo.withdrawLimitCoin
            : 0;
          this.securityInfo.phoneExist = phoneExist;
          this.securityInfo.emailExist = emailExist;
          this.securityInfo.passkeyExist = passkeyExist;

          this.securityInfo.restricted = withdrawInfo?.restricted;
          this.securityInfo.restrictPrompt = withdrawInfo?.restrictPrompt;

          phoneExist && this.rootStore.profileStore.setPhone(info.phone);
          emailExist && this.rootStore.profileStore.setEmail(info.email);
          showGuide &&
            this.rootStore.guideStore.hasGuide &&
            this.rootStore.guideStore.showGuide();
        })
      )
      .catch(
        action((res) => {
          this.fetching = false;
          // 隐藏loading
          this.rootStore.loadingStore.hideLoading();
          this.rootStore.loadingStore.showErrorDialog(res.msg);
        })
      );
  }
}
